import { BaseReport, BaseReportAsFile } from './base-report.model';

export enum ReportFileType {
  XLSX = 'XLSX',
  CSV = 'CSV'
}

export interface ReportItem {
  title: string;
  section: ReportSection;
  action: ActionReportEnum;
  permission: string[];
}

export enum ActionReportEnum {
  AWAITING_ALLOCATION_FOR_GROUP_ORDER = 'awaiting_allocation_for_group_order',
  VOUCHER_REPORT = 'voucher',
  CJX_VOUCHER_REPORT = 'cjx_voucher',
  STOCK_CARD = 'stockcard',
  SPECIAL_POINT_COMPENSATE = 'special_point_compensate',
  SALES_TRANSACTION = 'sales_transaction',
  CJX_SALES_TRANSACTION = 'cjx_sales_transaction',
  PROMOTION_COMPENSATE = 'promotion_compensate',
  SALES_SUMMARY = 'sales_summary',
  TOTE_ADJUSTMENT = 'tote_adjustment',
  INVENTORY_COUNT_TRANSACTION_TEMP = 'inventory_count_transaction_temp',
  MOVING_AVERAGE = 'moving_average',
  INVENTORY_COUNT_TRANSACTION = 'inventory_count_transaction',
  MONEY_IN = 'money_in',
  INVENTORY_ADJUSTMENT_REQUEST = 'inventory_adjustment_request',
  INVENTORY_VARIANCE = 'inventory_variance',
  DC_ASSORTMENT = 'dc_assortment',
  BILL_PAYMENT = 'bill_payment',
  SUPPLIER_COUPON_RECONCILE = 'supplier_coupon_reconcile',
  STORE_CONFIDENTIAL = 'store_confidential',
  SALES_TRANSACTION_CONFIDENTIAL = 'sales_transaction_confidential',
  COMPANY_ASSORTMENT = 'company_assortment',
  ASSORTMENT_CONFIDENTIAL = 'assortment_confidential',
  DESTROY_TRANSACTION = 'destroy_transaction',
  DESTROY_DOCUMENT = 'destroy_document',
  REWARD_TRANSACTION = 'reward_transaction',
  REDEEM_TRANSACTION = 'redeem_transaction',
  RECEIVE_ORDER_EXCEED = 'receive_order_exceed',
  AWAITING_FIRST_LOT = 'awaiting_first_lot',
  TEMPORARY_HOLD = 'temporary_hold',
  POINT_BURN_TRANSACTION = 'point_burn_transaction',
  POINT_EARN_TRANSACTION = 'point_earn_transaction',
  PRE_ORDER_TRANSACTION = 'pre_order_transaction',
  PRE_ORDER_TRANSACTION_CONFIDENTIAL = 'pre_order_transaction_confidential',
  PRE_ORDER_CATALOG_CONFIDENTIAL = 'pre_order_catalog_confidential',
  PRE_ORDER_COMPENSATE = 'pre_order_compensate',
  MEMBER_REWARD_TRANSACTION = 'member_reward_transaction',
  CJX_MEMBER_REWARD_TRANSACTION = 'cjx_member_reward_transaction',
  SUPPLIER_COUPON_ISSUE_TRANSACTION = 'supplier_coupon_issue_transaction',
  SUPPLIER_COUPON_TRANSACTION = 'supplier_coupon_transaction',
  MEMBER_REWARD_TRANSACTION_WITH_PRICE = 'member_reward_transaction_with_price',
  MEMBER_REWARD_ACCOUNTING_CONFIDENTIAL = 'member_reward_accounting_confidential',
  MEMBER_PROFILE_REPORT = 'cjx_member_profile',
  ACTIVITY_REPORT = 'cjx_activity_report',
  REFUND_TRANSACTION_REPORT_WITH_PRICE = 'refund_transaction_report_with_price',
  STORE_LOCATION_BY_DC = 'store_location_by_dc',
  GROUP_ORDER_UNPICKED_ITEM = 'group_order_unpicked_item',
  HOLD_ASSORTMENT = 'hold_assortment',
  PROMOTION = 'promotion',
  SPECIAL_POINT = 'special_point',
  SHIPMENT = 'shipment',
  RETURN_TO_WAREHOUSE_ORDER = 'return_to_warehouse_order',
  RETURN_TO_WAREHOUSE_GR = 'return_to_warehouse_gr',
  RETURN_TO_WAREHOUSE_CHARGE = 'return_to_warehouse_charge',
  RESPONSE = 'response',
  SURVEY = 'survey',
  TASK_ASSIGNMENT = 'task_assignment',
  FLASH_SALE_ORDER = 'flash_sale_order',
  ONLINE_COUPON_TRANSACTION = 'Online Coupon Transaction',
  ONLINE_COUPON_COMPENSATE = 'online_coupon_compensate',
  ORDER = 'order',
  REFUND_SUMMARY = 'refund_summary',
  DELIVERY_ORDER = 'delivery_order',
  RECEIVE_ORDER = 'receive_order',
  CLAIM = 'claim',
  STOCK_BY_PRODUCT = 'stock_by_product',
  STOCK_ADJUSTMENT = 'stock_adjustment',
  TRANSFER_ORDER = 'transfer_order',
  TRANSFER_GOODS_RECEIVE = 'transfer_goods_receive',
  USER = 'user',
  USER_CJX = 'user_cjx',
  PROFIT_SHARING = 'profit_sharing',
  SUPPLIER = 'supplier',
  STORE_CONSULTANT = 'store_consultant',
  STORE = 'store',
  STORE_ORDER_SCHEDULE = 'store_order_schedule',
  REWARD = 'reward',
  ONLINE_COUPON = 'online_coupon',
  ONLINE_COUPON_SUMMARY = 'online_coupon_summary',
  MEMBER_REWARD_CATALOG = 'member_reward_catalog',
  PRODUCT_BY_LOCATION = 'product_by_location',
  PRE_ORDER_CATALOG = 'pre_order_catalog',
  SHELF_FIX_ASSET = 'shelf_fix_asset',
  SHELF_INVENTORY = 'shelf_inventory',
  STORE_ASSORTMENT = 'store_assortment',
  HOLD_ORDER = 'hold_order',
  STOCK_BY_LOCATION = 'stock_by_location',
  PURCHASE_REQUEST = 'purchase_request',
  PURCHASE_ORDER = 'purchase_order',
  GOODS_RECEIVE = 'goods_receive',
  PRE_ORDER_CREDIT_REMAINING = 'pre_order_credit_remaining',
  PRODUCT_WAREHOUSE_MAPPING = 'PRODUCT_WAREHOUSE_MAPPING',
  PRODUCT_CATEGORY_FIXASSET_STOREUSE = 'PRODUCT_CATEGORY_FIXASSET_STOREUSE',
  PRODUCT_CATEGORY_INVENTORY = 'PRODUCT_CATEGORY_INVENTORY',
  PRE_ORDER_CATEGORY = 'PRE_ORDER_CATEGORY',
  SALE_SCHEDULE = 'SALE_SCHEDULE',
  SAP_STORE_CODE_MAPPING = 'SAP_STORE_CODE_MAPPING',
  STORE_APPROVAL_BYPASS = 'STORE_APPROVAL_BYPASS',
  CROSS_DOCK_INVOICE = 'CROSS_DOCK_INVOICE',
  STORE_TOTE = 'store_tote',
  STORE_TOTE_FINE = 'store_tote_fine',
  TOTE_IN_OUT = 'tote_in_out',
  TOTE_IN_TRACKING = 'tote_in_tracking',
  MANUAL_CHANGE_DELIVERY_STATUS = 'manual_change_delivery_status',
  COUNT_ITEM_IN_TOTE = 'count_item_in_tote',
  PROMOTION_V2 = 'promotion_v2',
  DESTROY_TRANSACTION_REPORT = 'destroy_transaction_report',
  PROMOTION_TRANSACTION = 'promotion_transaction',
  MATERIAL_REQUEST_TRANSACTION = 'material_request_transaction',
  REDUCE_TO_CLEAR_SUMMARY = 'reduce_to_clear_summary',
  REDUCE_TO_CLEAR_TRANSACTION = 'REDUCE_TO_CLEAR_TRANSACTION',
  CASH_SETTLEMENT_TRANSACTION_BEFORE_GO_LIVE = 'CASH_SETTLEMENT_TRANSACTION_BEFORE_GO_LIVE',
  CASH_SETTLEMENT_TRANSACTION = 'CASH_SETTLEMENT_TRANSACTION',
  RECEIPT_COUPON = 'RECEIPT_COUPON',
  STOCK_COUNT_BY_QI_SUMMARY = 'STOCK_COUNT_BY_QI_SUMMARY',
  STOCK_COUNT_BY_QI_TRANSACTION = 'STOCK_COUNT_BY_QI_TRANSACTION',
  STORE_AVAILABLE_ADJUSTMENT_REQUEST = 'STORE_AVAILABLE_ADJUSTMENT_REQUEST',
  STOCK_COUNT_ASSIGNMENT_SUMMARY = 'STOCK_COUNT_ASSIGNMENT_SUMMARY',
  STOCK_COUNT_ASSIGNMENT_TRANSACTION = 'STOCK_COUNT_ASSIGNMENT_TRANSACTION',
  STOCK_COUNT_BY_STAFF_TRANSACTION = 'STOCK_COUNT_BY_STAFF_TRANSACTION',
  STOCK_COUNT_BY_QI_DAILY_SUMMARY = 'STOCK_COUNT_BY_QI_DAILY_SUMMARY',
  STORE_EXPENSE = 'STORE_EXPENSE',
  STORE_OTHER_INCOME = 'STORE_OTHER_INCOME',
  SALES_PERFORMANCE = 'SALES_PERFORMANCE',
  SHIFT_RECORD = 'SHIFT_RECORD',
  MONEY_IN_OUT = 'MONEY_IN_OUT',
  CJX_SALES_SUMMARY = 'CJX_SALES_SUMMARY',
  CAFE_BILL_OF_MATERIALS_COST = 'CAFE_BILL_OF_MATERIALS_COST',
  CAFE_SALES_AND_PROFIT = 'CAFE_SALES_AND_PROFIT',
  SALES_TAX = 'SALES_TAX',
  CJX_SHELF_INVENTORY = 'CJX_SHELF_INVENTORY',
  REFILL_STOCK_SCHEDULE = 'REFILL_STOCK_SCHEDULE',
  GIFT_WITH_PURCHASE = 'GIFT_WITH_PURCHASE',
  REFILL_PRIORITY = 'REFILL_PRIORITY',
  STORE_PICKING_UNIT = 'STORE_PICKING_UNIT',
  GIFT_WITH_PURCHASE_TRANSACTION = 'GIFT_WITH_PURCHASE_TRANSACTION',
  STORE_STOCK_RECALL = 'STORE_STOCK_RECALL',
  RECALL_STOCK_PACKING_CONFIRMATION = 'RECALL_STOCK_PACKING_CONFIRMATION',
  STOCK_REFILL_SUMMARY = 'STOCK_REFILL_SUMMARY',
  STOCK_REFILL_PERFORMANCE = 'STOCK_REFILL_PERFORMANCE',
  CAFE_ORDER_PROCESSING_PERFORMANCE = 'CAFE_ORDER_PROCESSING_PERFORMANCE',
  RECALL_STOCK_CHECK_CONFIRMATION = 'RECALL_STOCK_CHECK_CONFIRMATION',
  RECALL_CREDIT_NOTE = 'RECALL_CREDIT_NOTE',
  LOADING_GROUP_BY_WAREHOUSE = 'LOADING_GROUP_BY_WAREHOUSE',
  DISPATCH_TOTE = 'DISPATCH_TOTE',
  RECEIVE_TOTE = 'RECEIVE_TOTE',
  RETURN_TOTE = 'RETURN_TOTE',
  STOCK_COUNT_SCHEDULE = 'STOCK_COUNT_SCHEDULE',
  SHELF_REPLENISHMENT_SUMMARY = 'SHELF_REPLENISHMENT_SUMMARY',
  SHELF_REPLENISHMENT_TRANSACTION = 'SHELF_REPLENISHMENT_TRANSACTION',
  QR_PAYMENT = 'QR_PAYMENT',
  SHELF_REPLENISHMENT_PHOTO_REVIEW = 'SHELF_REPLENISHMENT_PHOTO_REVIEW',
  PETTY_CASH_EVENT_BASED = 'PETTY_CASH_EVENT_BASED',
  PETTY_CASH_DEFAULT = 'PETTY_CASH_DEFAULT',
  SINGLE_LOCATION_STOCK_FRONT_STORE_ONLY = 'SINGLE_LOCATION_STOCK_FRONT_STORE_ONLY',
  CHECK_PRODUCT_TAG = 'CHECK_PRODUCT_TAG',
  COLLECT_EXPIRED_PROMOTION_TAG = 'COLLECT_EXPIRED_PROMOTION_TAG',
  BILL_PAYMENT_TRANSACTION = 'BILL_PAYMENT_TRANSACTION',
  STORE_GROUP = 'STORE_GROUP',
  MATERIAL_REQUEST_TYPE = 'MATERIAL_REQUEST_TYPE',
  STORE_EXPENSE_TYPE = 'STORE_EXPENSE_TYPE',
  SUPPLIER_PARTNER_COUPON = 'SUPPLIER_PARTNER_COUPON',
  CASH_COUNTING = 'CASH_COUNTING',
  EDC_PAYMENT_TRANSACTION = 'EDC_PAYMENT_TRANSACTION',
  STORE_EXPENSE_LIMIT = 'STORE_EXPENSE_LIMIT',
  LINEMAN_PRODUCT = 'LINEMAN_PRODUCT',
  DEPARTMENT = 'DEPARTMENT',
  LINEMAN_SALE_RECONCILE_TRANSACTION = 'LINEMAN_SALE_RECONCILE_TRANSACTION',
  LINEMAN_ORDER_MISSING_RECEIPT = 'LINEMAN_ORDER_MISSING_RECEIPT',
  AGENT_PAYMENT_TRANSACTION = 'AGENT_PAYMENT_TRANSACTION',
  MOBILE_PHONE_SALE_AND_REFUND = 'MOBILE_PHONE_SALE_AND_REFUND',
  RETURN_TO_SUPPLIER = 'RETURN_TO_SUPPLIER',
  CUSTOMER_SATISFACTION_SURVEY = 'CUSTOMER_SATISFACTION_SURVEY',
  REFUND_EXCEPTION_TRANSACTION = 'REFUND_EXCEPTION_TRANSACTION',
  PRODUCT = 'PRODUCT',
  PRODUCT_CONFIDENTIAL = 'PRODUCT_CONFIDENTIAL',
  PRODUCT_ECOMMERCE = 'PRODUCT_ECOMMERCE',
  PRODUCT_RETAIL_PRICE_CONFIDENTIAL = 'PRODUCT_RETAIL_PRICE_CONFIDENTIAL',
  PRODUCT_BRAND = 'PRODUCT_BRAND',
  PRODUCT_ATTRIBUTE = 'PRODUCT_ATTRIBUTE',
  ALTERNATIVE = 'ALTERNATIVE',
  ONLINE_PRODUCT_CATEGORY_OWN_DELIVERY = 'ONLINE_PRODUCT_CATEGORY_OWN_DELIVERY'
}

export enum ReportSection {
  TD_NEST = 'TD_NEST',
  TD_POS = 'TD_POS',
  TD_EYES = 'TD_EYES',
  PERFORMANCE = 'PERFORMANCE',
  OTHERS = 'OTHERS'
}

export class StockCardExportCriteria extends BaseReport {
  location: any;
  locationType: string;
  documentDateFrom?: string;
  documentDateTo?: string;
  segment: string;
  family?: string;
  classCode?: string;
  subClass?: string;

  constructor(init?: Partial<StockCardExportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class VoucherCriteria extends BaseReport {
  receiptDateFrom?: string;
  receiptDateTo?: string;
  fileType: string;

  constructor(init?: Partial<VoucherCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class VoucherExportCriteria extends BaseReport {
  receiptDateFrom?: string;
  receiptDateTo?: string;
  fileType: string;

  constructor(init?: Partial<VoucherExportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class CJXVoucherExportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  storeCodes?: string[];
  fileType: string;

  constructor(init?: Partial<VoucherExportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class SalesTransactionExportCriteria extends BaseReport {
  transactionDateFrom?: string;
  transactionDateTo?: string;
  store?: string;
  salesType?: string;
  fileType?: string;

  constructor(init?: Partial<SalesTransactionExportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class PreOrderCatalogExportCriteria extends BaseReport {
  status?: string;
  validDateFrom?: string;
  validDateTo?: string;
  effectiveDateFrom?: string;
  effectiveDateTo?: string;
  expireDateFrom?: string;
  expireDateTo?: string;
  fileType: ReportFileType;

  constructor(init?: Partial<PreOrderCatalogExportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class PreOrderCatalogConfidentialCriteria extends BaseReport {
  status?: string;
  categoryLv1: string;
  categoryLv2: string;
  categoryLv3: string;
  fileType: ReportFileType;

  constructor(init?: Partial<PreOrderCatalogConfidentialCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class SalesSummaryReportExportCriteria extends BaseReport {
  createdDateFrom?: string;
  createdDateTo?: string;
  storeType?: string;
  fileType: ReportFileType;

  constructor(init?: Partial<SalesSummaryReportExportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class StoreLocationByDcReportCriteria extends BaseReportAsFile {
  constructor(init?: Partial<StoreLocationByDcReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class InventoryCountTransactionTempReportExportCriteria extends BaseReport {
  createdDateFrom?: string;
  createdDateTo?: string;
  storeType?: string;
  storeCodes?: string | string[];
  fileType?: string;

  constructor(init?: Partial<InventoryCountTransactionTempReportExportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class PromotionCompensateReportExportCriteria extends BaseReport {
  receiptDateFrom: string;
  receiptDateTo: string;
  storeType?: string;
  supplierCode?: string;
  classes?: string[];
  fileType: string;

  constructor(init?: Partial<PromotionCompensateReportExportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class MovingAverageReportExportCriteria extends BaseReport {
  createdDateFrom?: string;
  createdDateTo?: string;

  constructor(init?: Partial<MovingAverageReportExportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class InventoryCountTransactionReportExportCriteria extends BaseReport {
  createdDateFrom?: string;
  createdDateTo?: string;
  storeType?: string;
  storeCodes?: string | string[];
  fileType?: string;

  constructor(init?: Partial<InventoryCountTransactionReportExportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class InventoryAdjustmentRequestReportExportCriteria extends BaseReport {
  createdDateFrom?: string;
  createdDateTo?: string;
  storeType?: string;
  storeNo?: string;
  fileType?: string;

  constructor(init?: Partial<InventoryAdjustmentRequestReportExportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class MoneyInReportCriteria extends BaseReport {
  createdDateFrom?: string;
  createdDateTo?: string;
  store?: string[];
  fileType: ReportFileType;

  constructor(init?: Partial<MoneyInReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class InventoryVarianceCriteria extends BaseReport {
  createdDate?: string;
  storeNo?: string[];

  constructor(init?: Partial<InventoryVarianceCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class DcAssortmentExportCriteria extends BaseReport {
  warehouseCode: string[];
  fileType: string;

  constructor(init?: Partial<DcAssortmentExportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class BillPaymentReportCriteria extends BaseReport {
  saleDateFrom?: string;
  saleDateTo?: string;
  paymentDateFrom?: string;
  paymentDateTo?: string;
  store?: string;
  status?: string;
  fileType: ReportFileType;

  constructor(init?: Partial<BillPaymentReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class SupplierCouponReconcileReportCriteria extends BaseReport {
  transactionDateFrom: string;
  transactionDateTo: string;
  storeNo?: string;

  constructor(init?: Partial<SupplierCouponReconcileReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class SupplierCouponReconcileReportExportCriteria extends BaseReport {
  transactionDateFrom?: string;
  transactionDateTo?: string;
  store?: string[];

  constructor(init?: Partial<SupplierCouponReconcileReportExportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class SupplierCouponTransactionExportCriteria extends BaseReport {
  createdDateFrom?: string;
  createdDateTo?: string;
  storeCodes?: string[];
  fileType?: string;

  constructor(init?: Partial<SupplierCouponTransactionExportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class DestroyTransactionReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  storeType?: string;
  storeNo?: string[];
  fileType?: string;

  constructor(init?: Partial<DestroyTransactionReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class DestroyTransactionReportExportCriteria extends BaseReport {
  createdDateFrom?: Date;
  createdDateTo?: Date;
  storeType?: string;
  storeNo?: string[];
  fileType?: string;

  constructor(init?: Partial<DestroyTransactionReportExportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class DestroyDocumentReportCriteria extends BaseReport {
  docNo: string;

  constructor(init?: Partial<DestroyDocumentReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class RewardTransactionReportCriteria extends BaseReport {
  transactionDateFrom: string;
  transactionDateTo: string;
  storeCodes?: string[];
  fileType: ReportFileType;

  constructor(init?: Partial<RewardTransactionReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class RedeemTransactionReportCriteria extends BaseReport {
  transactionDateFrom: string;
  transactionDateTo: string;
  storeCodes?: string[];
  fileType: ReportFileType;

  constructor(init?: Partial<RedeemTransactionReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class ReceiveOrderExceedReportCriteria extends BaseReport {
  receiveOrderDateFrom?: string;
  receiveOrderDateTo?: string;

  constructor(init?: Partial<ReceiveOrderExceedReportExportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class ReceiveOrderExceedReportExportCriteria extends BaseReport {
  receiveOrderDateFrom?: string;
  receiveOrderDateTo?: string;

  constructor(init?: Partial<ReceiveOrderExceedReportExportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class AwaitingFirstLotExportCriteria extends BaseReport {
  openDateFrom?: string;
  openDateTo?: string;
  storeType?: string[];
  region?: string[];
  state?: string[];
  fileType: ReportFileType;

  constructor(init?: Partial<AwaitingFirstLotExportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class OrderProcessingHoldCriteria extends BaseReport {
  requestedDateFrom?: string | null;
  requestedDateTo?: string | null;
  store?: string | string[] | null;
  delistSuggestion?: string | string[];
  fileType: ReportFileType;

  constructor(init?: Partial<OrderProcessingHoldCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class PreOrderTransactionReportCriteria extends BaseReport {
  transactionDateFrom: string;
  transactionDateTo: string;
  preorderDueDateFrom?: string;
  preorderDueDateTo?: string;
  storeCodes?: string[];
  fileType?: ReportFileType;

  constructor(init?: Partial<PreOrderTransactionReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class PreOrderCompensateReportCriteria extends BaseReport {
  transactionDateFrom: string;
  transactionDateTo: string;
  storeCode?: string;
  supplierCode?: string;
  fileType: ReportFileType;

  constructor(init?: Partial<PreOrderCompensateReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class PreOrderAccountingReportCriteria extends BaseReport {
  transactionDateFrom: string;
  transactionDateTo: string;
  storeCodes?: string;

  constructor(init?: Partial<PreOrderAccountingReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class GenerateMyReportResponse {
  id: string;
  version: number;
  requestNo: string;
  reportName: string;
  jobId: string;
  createBy: string;
  requestedDate: string;
  completedDate: string;
  status: string;
}

export class MemberRewardTransactionReportCriteria extends BaseReport {
  transactionDateFrom: string;
  transactionDateTo: string;
  storeCodes?: string[];
  fileType?: ReportFileType;

  constructor(init?: Partial<MemberRewardTransactionReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class MemberRewardTransactionCriteria {
  memberRewardTransactionDateFrom: string;
  memberRewardTransactionDateTo: string;
  store: string[];
  fileType: ReportFileType;

  constructor(init?: Partial<MemberRewardTransactionCriteria>) {
    Object.assign(this, init);
  }
}

export class MemberRewardAccountingReportCriteria extends BaseReport {
  transactionDateFrom: string;
  transactionDateTo: string;
  storeCodes?: string;

  constructor(init?: Partial<MemberRewardAccountingReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class CJXMemberRewardTransactionCriteria {
  transactionDateFrom: string;
  transactionDateTo: string;
  storeCodes: string[];
  fileType: ReportFileType;

  constructor(init?: Partial<CJXMemberRewardTransactionCriteria>) {
    Object.assign(this, init);
  }
}

export class RefundTransactionReportConfidentialExportCriteria extends BaseReport {
  transactionDateFrom?: string;
  transactionDateTo?: string;
  refundTypes?: string[];
  fileType?: string;

  constructor(init?: Partial<RefundTransactionReportConfidentialExportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class RefundExportCriteria extends BaseReport {
  createdDateTo: string;
  createdDateFrom: string;
  storeCodes?: string[];
  fileType: string;

  constructor(init?: Partial<RefundExportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class GroupOrderUnpickedItemReportCriteria extends BaseReport {
  dispatchDateFrom: string;
  dispatchDateTo: string;
  storeCode: string[];
  warehouseCode: string[];
  orderType: string[];
  fileType: string;

  constructor(init?: Partial<GroupOrderUnpickedItemReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class AwaitingAllocationForGroupOrderReportCriteria extends BaseReport {
  orderDateFrom: string;
  orderDateTo: string;
  storeCode: string[];
  warehouseCode: string[];
  orderType: string[];
  fileType: string;

  constructor(init?: Partial<AwaitingAllocationForGroupOrderReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class PromotionReportCriteria extends BaseReport {
  effectiveDateFrom: string;
  effectiveDateTo: string;
  validDateFrom: string;
  validDateTo: string;
  status?: string;
  fileType: string;

  constructor(init?: Partial<PromotionReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class SpecialPointCompensateReportCriteria extends BaseReport {
  transactionDateFrom: string;
  transactionDateTo: string;
  storeNos: string[];
  supplierCode: string;
  fileType: string;

  constructor(init?: Partial<SpecialPointCompensateReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class SpecialPointReportCriteria extends BaseReport {
  effectiveDateFrom: string;
  effectiveDateTo: string;
  expireDateFrom: string;
  expireDateTo: string;
  validDateFrom: string;
  validDateTo: string;
  offerSupplierCode: string[];
  status: string[];
  fileType: string;

  constructor(init?: Partial<SpecialPointReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class ResponseReportCriteria extends BaseReport {
  taskNo?: string;
  status?: string;
  releaseDateFrom?: string;
  releaseDateTo?: string;
  responseDueDateFrom?: string;
  responseDueDateTo?: string;
  fileType: string;

  constructor(init?: Partial<ResponseReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class SurveyReportCriteria extends BaseReport {
  taskNo: string;
  fileType: string;

  constructor(init?: Partial<SurveyReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class ReturnToWarehouseOrderReportCriteria {
  createdDateFrom: string;
  createdDateTo: string;
  shipFromCodeName: string;
  shipToCodeName: string;
  status: string;
  returnType: string;
  fileType: string;
}

export class ReturnToWarehouseGRReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  shipFromCodeName: string;
  shipToCodeName: string;
  status: string;
  returnType: string;
  fileType: string;

  constructor(init?: Partial<ReturnToWarehouseGRReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class ReturnToWarehouseChargeReportCriteria {
  createdDateFrom: string;
  createdDateTo: string;
  shipFromCodeName: string;
  shipToCodeName: string;
  returnType: string;
  fileType: string;
}

export class TaskAssignmentReportCriteria extends BaseReport {
  releaseDateFrom: string;
  releaseDateTo: string;
  responseDueDateFrom: string;
  responseDueDateTo: string;
}

export class FlashSaleOrderReportCriteria {
  flashSaleId: string;
  storeCodes?: string[];
  fileType: string;
}

export class TemporaryHoldReportCriteria extends BaseReport {
  requestedDateFrom: string;
  requestedDateTo: string;
  store: string | string[];
  delistSuggestion: boolean;
  fileType: string;

  constructor(init?: Partial<TemporaryHoldReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class OnlineCouponTransactionCriteria extends BaseReport {
  transactionDateFrom: string;
  transactionDateTo: string;
  supplierCode?: string;
  fileType: ReportFileType;
  couponType?: string[];

  constructor(init?: Partial<OnlineCouponTransactionCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class UserReportCriteria extends BaseReport {
  merchantNo: any;
  departmentCodes: string[];
  roles: string[];
  fileType: string;

  constructor(init?: Partial<UserReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class HoldOrderReportCriteria extends BaseReport {
  holdDateFrom: string;
  holdDateTo: string;
  storeCodes?: string[];
  fileType: string;
}

export class PointEarnTransactionReportCriteria extends BaseReport {
  transactionDateFrom: string;
  transactionDateTo: string;
  storeCodes?: string[];
  memberId: string;
  fileType: string;

  constructor(init?: Partial<PointEarnTransactionReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class PointBurnTransactionReportCriteria extends BaseReport {
  transactionDateFrom: string;
  transactionDateTo: string;
  storeCode: string[];
  fileType: string;

  constructor(init?: Partial<PointBurnTransactionReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class PreOrderCreditRemainingReportCriteria extends BaseReport {
  creditDateFrom: string;
  creditDateTo: string;
  storeCodes: string[];
  fileType: string;

  constructor(init?: Partial<PreOrderCreditRemainingReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class OnlineCouponCompensateCriteria extends BaseReport {
  transactionDateFrom: string;
  transactionDateTo: string;
  couponType?: string[];
  storeCode?: string[];
  supplierCode?: string;
  fileType: string;

  constructor(init?: Partial<OnlineCouponCompensateCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class StoreApprovalBypassReportCriteria extends BaseReport {
  transactionDateFrom: string;
  transactionDateTo: string;
  storeCodes: string[];
  fileType: string;

  constructor(init?: Partial<StoreApprovalBypassReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class ToteAdjustmentReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  adjustmentType: string[];
  locationType: string[];
  storeCodes: string[];
  fileType: string;

  constructor(init?: Partial<ToteAdjustmentReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class StoreToteReportCriteria extends BaseReport {
  storeCodes: string[];
  toteDisplayBy: string;
  fileType: string;

  constructor(init?: Partial<StoreToteReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class StoreToteFineReportCriteria extends BaseReport {
  transactionDateFrom: string;
  transactionDateTo: string;
  fineType: string;
  location: string[];
  fileType: string;

  constructor(init?: Partial<StoreToteFineReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class CrossDockInvoiceReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  warehouseCodes: string[];
  fileType: string;

  constructor(init?: Partial<CrossDockInvoiceReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class ManualChangeDeliveryStatusReportCriteria extends BaseReport {
  manualChangeDateFrom: string;
  manualChangeDateTo: string;
  fileType: string;

  constructor(init?: Partial<ManualChangeDeliveryStatusReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class PromotionV2ReportCriteria extends BaseReport {
  validDateFrom: string;
  validDateTo: string;
  type?: string;
  discountType?: string;
  memberOnly?: boolean;
  status?: string;
  fileType: string;

  constructor(init?: Partial<PromotionV2ReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class DestroyTransactionExportReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  status: string[];
  fileType: string;
  storeCodes: string[];

  constructor(init?: Partial<DestroyTransactionExportReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class ReduceToClearTransactionReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  fileType: string;
  storeCodes: string[];

  constructor(init?: Partial<ReduceToClearTransactionReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class PromotionTransactionReportCriteria extends BaseReport {
  receiptDateFrom: string;
  receiptDateTo: string;
  storeCodes?: string[];
  supplierCode?: string[];
  fileType: string;

  constructor(init?: Partial<PromotionTransactionReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class CJXSalesTransactionReportCriteria extends BaseReport {
  transactionDateFrom: string;
  transactionDateTo: string;
  storeCodes: string[];
  salesType: string[];
  fileType: string;

  constructor(init?: Partial<CJXSalesTransactionReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class MaterialRequestTransactionCriteria extends BaseReport {
  transactionDateFrom: string;
  transactionDateTo: string;
  storeCodes?: string[];
  fileType: string;

  constructor(init?: Partial<MaterialRequestTransactionCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class ShelfInventoryReportCriteria extends BaseReport {
  no: string[];
  status: string[];
  fileType: string;

  constructor(init?: Partial<ShelfInventoryReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class ShelfFixAssetReportCriteria extends BaseReport {
  selected: string[];
  status: string;
  fileType: string;

  constructor(init?: Partial<ShelfFixAssetReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class ReduceToClearSummaryReportCriteria extends BaseReport {
  createdDateFrom?: string;
  createdDateTo?: string;
  storeCodes?: string[];
  status?: string[];
  fileType?: string;

  constructor(init?: Partial<ReduceToClearSummaryReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class CashSettlementTransactionReportCriteria extends BaseReport {
  saleScheduleDateFrom: string;
  saleScheduleDateTo: string;
  transferDateFrom: string;
  transferDateTo: string;
  storeCodes: string[];
  settlementStatuses: string[];
  fileType: string;

  constructor(init?: Partial<CashSettlementTransactionReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class ReceiptCouponTransactionReportCriteria extends BaseReport {
  offerDateFrom: string;
  offerDateTo: string;
  redeemDateFrom: string;
  redeemDateTo: string;
  fileType: string;
  status: string[];
  type: string[];

  constructor(init?: Partial<ReceiptCouponTransactionReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class StockCountByQISummaryReportCriteria extends BaseReport {
  countDateFrom: string;
  countDateTo: string;
  storeCodes?: string[];
  fileType: string;

  constructor(init?: Partial<StockCountByQISummaryReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class StockCountByQITransactionReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  storeCodes?: string[];
  compareStockResults: string[];
  fileType: string;

  constructor(init?: Partial<StockCountByQITransactionReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class StoreAvailableAdjustmentRequestReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  storeCodes?: string[];
  fileType: string;

  constructor(init?: Partial<StoreAvailableAdjustmentRequestReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class StockCountAssignmentSummaryReportCriteria extends BaseReport {
  countPeriodDateFrom: string;
  countPeriodDateTo: string;
  storeCodes?: string[];
  stockCountStatus?: string[];
  fileType: string;

  constructor(init?: Partial<StockCountAssignmentSummaryReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class StockCountAssignmentTransactionReportCriteria extends BaseReport {
  countPeriodDateFrom: string;
  countPeriodDateTo: string;
  storeCodes?: string[];
  fileType: string;

  constructor(init?: Partial<StockCountAssignmentTransactionReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class StockCountByStaffTransactionReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  storeCodes?: string[];
  fileType: string;

  constructor(init?: Partial<StockCountByStaffTransactionReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class StockCountByQISummaryDailyReportCriteria extends BaseReport {
  countDate: string;
  storeNo: string;

  constructor(init?: Partial<StockCountByQISummaryDailyReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class StoreExpenseReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  saleScheduleDateFrom: string;
  saleScheduleDateTo: string;
  storeCodes?: string[];
  storeExpenseRequestStatuses?: string[];
  fileType: string;

  constructor(init?: Partial<StoreExpenseReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class StoreOtherIncomeReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  saleScheduleDateFrom: string;
  saleScheduleDateTo: string;
  storeCodes?: string[];
  fileType: string;

  constructor(init?: Partial<StoreOtherIncomeReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class SalePerformanceReportCriteria extends BaseReport {
  dateFrom: string;
  dateTo: string;
  storeCodes?: string[];
  fileType: string;

  constructor(init?: Partial<SalePerformanceReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class CountItemInToteReportCriteria extends BaseReport {
  receiveDateFrom: string;
  receiveDateTo: string;
  countDateFrom: string;
  countDateTo: string;
  storeCodes: string[];
  status: string[];
  fileType: string;

  constructor(init?: Partial<CountItemInToteReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class ShiftRecordReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  saleScheduleDateFrom: string;
  saleScheduleDateTo: string;
  storeCodes?: string[];
  fileType: string;

  constructor(init?: Partial<ShiftRecordReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class MoneyInOutReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  saleScheduleDateFrom: string;
  saleScheduleDateTo: string;
  storeCodes?: string[];
  fileType: string;

  constructor(init?: Partial<MoneyInOutReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class CJXSalesSummaryReportCriteria extends BaseReport {
  saleScheduleDateFrom: string;
  saleScheduleDateTo: string;
  storeCodes?: string[];
  fileType: string;

  constructor(init?: Partial<CJXSalesSummaryReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class CafeBillOfMaterialsCostReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  storeCodes?: string[];
  fileType: string;

  constructor(init?: Partial<CafeBillOfMaterialsCostReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class CafeSalesAndProfitReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  storeCodes?: string[];
  fileType: string;

  constructor(init?: Partial<CafeSalesAndProfitReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class SalesTaxReportCriteria extends BaseReport {
  asOfMonthFrom: string;
  asOfMonthTo: string;
  storeCodes?: string[];
  language: string;
  fileType: string;

  constructor(init?: Partial<SalesTaxReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class MemberProfileReportCriteria extends BaseReport {
  applyDateFrom: string;
  applyDateTo: string;
  fileType: string;

  constructor(init?: Partial<MemberProfileReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class PointActivityReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  fileType: string;

  constructor(init?: Partial<MemberProfileReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class GiftWithPurchaseReportCriteria extends BaseReport {
  validDateFrom: string;
  validDateTo: string;
  fileType: string;

  constructor(init?: Partial<GiftWithPurchaseReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class GiftWithPurchaseTransactionReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  storeCodes?: string[];
  supplierCode?: string[];
  fileType: string;

  constructor(init?: Partial<GiftWithPurchaseTransactionReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class StoreStockRecallReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  fileType: string;

  constructor(init?: Partial<StoreStockRecallReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class RecallStockPackingConfirmationReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  fileType: string;

  constructor(init?: Partial<RecallStockPackingConfirmationReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class StockRefillSummaryCriteria extends BaseReport {
  refillScheduleDateFrom: string;
  refillScheduleDateTo: string;
  storeCodes?: string[];
  fileType: string;

  constructor(init?: Partial<StockRefillSummaryCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class StockRefillPerformanceCriteria extends BaseReport {
  refillScheduleDateFrom: string;
  refillScheduleDateTo: string;
  storeCodes?: string[];
  fileType: string;

  constructor(init?: Partial<StockRefillPerformanceCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class CafeOrderProcessingPerformanceReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  storeCodes: string[];
  fileType: string;

  constructor(init?: Partial<CafeOrderProcessingPerformanceReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class RecallStockCheckConfirmationReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  fileType: string;

  constructor(init?: Partial<RecallStockCheckConfirmationReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class RecallCreditNoteReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  fileType: string;

  constructor(init?: Partial<RecallCreditNoteReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class PurchaseRequestReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  locations: string[];
  purchaseTypes: string[];
  statuses: string[];
  fileType: string;

  constructor(init?: Partial<PurchaseRequestReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class PurchaseOrderReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  locations: string[];
  purchaseTypes: string[];
  statuses: string[];
  fileType: string;

  constructor(init?: Partial<PurchaseOrderReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class QRPaymentTransactionReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  storeCodes: string[];
  fileType: string;

  constructor(init?: Partial<QRPaymentTransactionReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class LoadingGroupByWarehouseCriteria extends BaseReport {
  warehouseCode: string[];
  productTypes: string[];
  fileType: string;

  constructor(init?: Partial<LoadingGroupByWarehouseCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class DispatchToteReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  shipFrom: string;
  shipTo: string;
  toteId: string;
  fileType: string;

  constructor(init?: Partial<DispatchToteReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class ReceiveToteReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  store: string;
  toteId: string;
  fileType: string;

  constructor(init?: Partial<ReceiveToteReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class ReturnToteReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  returnFrom: string;
  returnTo: string;
  toteId: string;
  fileType: string;

  constructor(init?: Partial<ReturnToteReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class ShelfReplenishmentSummaryReportCriteria extends BaseReport {
  refillDate: string;
  storeCodes: string[];
  fileType: string;

  constructor(init?: Partial<ShelfReplenishmentSummaryReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class ShelfReplenishmentTransactionReportCriteria extends BaseReport {
  refillScheduleDateFrom: string;
  refillScheduleDateTo: string;
  storeCodes: string[];
  fileType: string;

  constructor(init?: Partial<ShelfReplenishmentTransactionReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class ShelfReplenishmentPhotoReviewCriteria extends BaseReport {
  receivedDateFrom?: string | null;
  receivedDateTo?: string | null;
  verifiedDateFrom?: string | null;
  verifiedDateTo?: string | null;
  storeCodes?: string[] | null;
  fileType: ReportFileType;

  constructor(init?: Partial<ShelfReplenishmentPhotoReviewCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class StoreGroupExportCriteria extends BaseReport {
  fileType: string;

  constructor(init?: Partial<StoreGroupExportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class CheckProductTagCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  storeCodes?: string[];
  fileType: string;

  constructor(init?: Partial<CheckProductTagCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class CollectExpiredPromotionTagCriteria extends BaseReport {
  promotionExpiredDateFrom: string;
  promotionExpiredDateTo: string;
  storeCodes?: string[];
  fileType: string;

  constructor(init?: Partial<CollectExpiredPromotionTagCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class BillPaymentTransactionReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  saleScheduleDateFrom: string;
  saleScheduleDateTo: string;
  storeCodes: string[];
  fileType: string;

  constructor(init?: Partial<BillPaymentTransactionReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class SupplierPartnerCouponCriteria extends BaseReport {
  offerValidDateFrom?: string;
  offerValidDateTo?: string;
  redeemValidDateFrom?: string;
  redeemValidDateTo?: string;
  couponDiscountType?: string[];
  status?: string[];
  fileType: string;

  constructor(init?: Partial<SupplierPartnerCouponCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class CashCountingReportCriteria extends BaseReport {
  saleScheduleDateFrom: string;
  saleScheduleDateTo: string;
  storeCodes: string[];
  fileType: string;

  constructor(init?: Partial<CashCountingReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class EdcPaymentTransactionReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  storeCodes: string[];
  fileType: string;

  constructor(init?: Partial<EdcPaymentTransactionReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class LinemanProductCriteria extends BaseReport {
  fileType: string;

  constructor(init?: Partial<LinemanProductCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class LinemanSalesReconcileTransactionReportCriteria extends BaseReport {
  receiptDateFrom: string;
  receiptDateTo: string;
  linemanOrderNo: string;
  storeCodes: string[];
  fileType: string;

  constructor(init?: Partial<LinemanSalesReconcileTransactionReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class LinemanOrderMissingReceiptReportCriteria extends BaseReport {
  linemanOrderDateFrom: string;
  linemanOrderDateTo: string;
  fileType: string;

  constructor(init?: Partial<LinemanOrderMissingReceiptReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class AgentPaymentTransactionReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  storeCodes: string[];
  fileType: string;
}

export class MobilePhoneSaleAndRefundReportCriteria extends BaseReport {
  createdDate: string;
  storeCodes: string[];
  fileType: string;

  constructor(init?: Partial<MobilePhoneSaleAndRefundReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class RefundExceptionTransactionReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  submissionDateFrom: string;
  submissionDateTo: string;
  refundCompletedDateFrom: string;
  refundCompletedDateTo: string;
  storeCodes?: string[];
  fileType: string;

  constructor(init?: Partial<RefundExceptionTransactionReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class ReturnToSupplierReportCriteria extends BaseReport {
  createdDateFrom: string;
  createdDateTo: string;
  storeCodes: string[];
  fileType: string;

  constructor(init?: Partial<ReturnToSupplierReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class CustomerSatisfactionSurveyReportCriteria extends BaseReport {
  createdDate: string;
  storeCodes: string[];
  fileType: string;

  constructor(init?: Partial<CustomerSatisfactionSurveyReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class ProductReportExportCriteria extends BaseReport {
  segment?: string | null;
  family?: string | null;
  classCode?: string | null;
  subClass?: string | null;
  productType?: string[] | null;
  brands?: string[] | null;
  deliverySources?: string[] | null;
  productStatuses?: string[] | null;
  mainProductImages?: string[] | null;
  fileType: string;

  constructor(init?: Partial<ProductReportExportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class ProductRetailPriceConfidentialReportCriteria extends BaseReport {
  segment?: string | null;
  family?: string | null;
  classCode?: string | null;
  subClass?: string | null;
  brands?: string[] | null;
  productStatuses?: string[] | null;
  fileType: string;

  constructor(init?: Partial<ProductRetailPriceConfidentialReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export class ProductEcommerceReportCriteria extends BaseReport {
  categories?: string | null;
  subCategories?: string | null;
  brands?: string[] | null;
  productStatuses?: string[] | null;
  fileType: string;

  constructor(init?: Partial<ProductEcommerceReportCriteria>) {
    super();
    Object.assign(this, init);
  }
}
